import { render, staticRenderFns } from "./TheFormAddresses.vue?vue&type=template&id=60524cfa&scoped=true&"
import script from "./TheFormAddresses.vue?vue&type=script&lang=ts&"
export * from "./TheFormAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60524cfa",
  null
  
)

export default component.exports